import { Close } from '@mui/icons-material';
import { IconButton, Paper, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { setActiveWindow, setTaskSelectedItem } from 'app/actions/map';
import { MapTaskInfoList } from 'app/pages/Map';
import React from 'react';
import Draggable from 'react-draggable';
import { useDispatch, useSelector } from 'react-redux';

const MapTaskWindow = () => {
  const dispatch = useDispatch();
  const { activeWindow, taskSelectedItem } = useSelector((state) => state.map);

  const handleActiveWindow = () => dispatch(setActiveWindow('task'));

  const handleCloseWindowClick = () => dispatch(setTaskSelectedItem(null));

  if (!taskSelectedItem) {
    return <React.Fragment />;
  }

  return (
    <Draggable bounds='parent' handle='.header-draggable'>
      <Stack
        direction='column'
        onClick={handleActiveWindow}
        sx={(theme) => ({
          position: 'absolute',
          right: '80px',
          top: theme.spacing(4),
          minWidth: '525px',
          maxWidth: '525px',
          maxHeight: '630px',
          zIndex: '1050',
          overflow: 'hidden',
          bgcolor: 'background.paper',
          boxShadow: '0 1px 3px ' + alpha(theme.palette.grey.main, 0.12),
          borderRadius: theme.shape.borderRadius,
          transform: 'translate(0px, 0px)',
          '.header-draggable': {
            width: '100%',
            cursor: 'grab',
            minHeight: '44px',
            padding: '10px 140px',
            '.MuiTypography-root': {
              padding: theme.spacing(0, 2),
            },
          },
          '&.react-draggable-dragging .header-draggable': {
            cursor: 'grabbing',
          },
          ...(activeWindow === 'task' && {
            zIndex: '1051',
          }),
        })}>
        <Stack
          direction='column'
          sx={{
            userSelect: 'none',
            bgcolor: 'background.default',
            '.MuiTypography-root': {
              fontSize: '13px',
            },
          }}>
          <Stack direction='row' justifyContent='center' alignItems='center' className='header-draggable'>
            <Typography variant='h6' component='span'>
              {taskSelectedItem.transport_number}_{moment(taskSelectedItem.task_date).format('DD.MM.YYYY_HH:mm:ss')}
            </Typography>
          </Stack>
          <Stack
            direction='row'
            alignItems='center'
            component='ul'
            sx={(theme) => ({
              position: 'absolute',
              right: '8px',
              top: '7px',
              margin: '0',
              marginLeft: 'auto',
              listStyle: 'none',
              li: {
                margin: '0',
                padding: '0',
                display: 'flex',
                alignItems: 'center',
                button: {
                  width: '30px',
                  height: '30px',
                  '.maximizeIcon, .minimizeIcon': {
                    width: '16px',
                    height: '16px',
                  },
                },
              },
              'li:not(:last-of-type) path': {
                fill: theme.palette.text.secondary,
              },
            })}>
            <li>
              <IconButton color='default' onClick={handleCloseWindowClick}>
                <Close fontSize='small' />
              </IconButton>
            </li>
          </Stack>
        </Stack>
        <Stack
          direction='column'
          sx={(theme) => ({
            padding: theme.spacing(2),
          })}>
          <Stack
            direction='row'
            sx={(theme) => ({
              display: 'grid',
              gap: 2,
              marginBottom: theme.spacing(1),
              '.MuiPaper-root': {
                position: 'relative',
                border: 'none',
                display: 'grid',
                gap: '6px',
                gridTemplateColumns: 'repeat(2, 1fr)',
              },
              '.MuiPaper-row': {
                display: 'grid',
                gap: 1,
                gridTemplateColumns: 'repeat(6, 1fr)',
                '.MuiTypography-root:first-of-type': {
                  color: 'text.secondary',
                },
              },
              '.MuiPaper-row .MuiTypography-root:first-of-type': {
                gridRow: '1',
                gridColumn: '1/4',
              },
              '.MuiPaper-row .MuiTypography-root:last-of-type': {
                gridRow: '1',
                gridColumn: '4/7',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                'span:nth-of-type(2)': {
                  paddingLeft: theme.spacing(0.5),
                },
              },
            })}>
            <Paper variant='outlined'>
              <Stack className='MuiPaper-column'>
                <Stack className='MuiPaper-row'>
                  <Typography variant='body1'>Номер задания</Typography>
                  <Typography variant='body1'>{taskSelectedItem.id}</Typography>
                </Stack>
                <Stack className='MuiPaper-row'>
                  <Typography variant='body1'>Статус задания</Typography>
                  <Typography variant='body1'>
                    {
                      {
                        finished: 'Завершено',
                        active: 'Активно',
                      }[taskSelectedItem.status]
                    }
                  </Typography>
                </Stack>
              </Stack>
              <Stack className='MuiPaper-column'>
                <Stack className='MuiPaper-row'>
                  <Typography variant='body1'>Дата начала</Typography>
                  <Typography variant='body1'>{moment(taskSelectedItem.task_date).format('DD.MM.YYYY HH:mm:ss')}</Typography>
                </Stack>
                <Stack className='MuiPaper-row'>
                  <Typography variant='body1'>Дата завершения</Typography>
                  <Typography variant='body1'>
                    {moment(taskSelectedItem.finished_date).isValid() &&
                      moment(taskSelectedItem.finished_date).format('DD.MM.YYYY HH:mm:ss')}
                  </Typography>
                </Stack>
              </Stack>
            </Paper>
          </Stack>
          <MapTaskInfoList />
        </Stack>
      </Stack>
    </Draggable>
  );
};

export default MapTaskWindow;
